import { forwardRef, type Ref, type SVGProps } from "react";
const IconTabletOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M26 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 26H6v-4h20zm0-6H6V4h20z" />
    <path d="M16 25a1 1 0 1 0 0 2 1 1 0 1 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconTabletOutlineSVG);
ForwardRef.displayName = "IconTabletOutline";
export { ForwardRef as IconTabletOutline };
